module.exports = __webpack_public_path__ + "static/media/banner-login.111c46cc.jpg";